























import Vue from "vue";
import Pipeline from "@/components/shared/pipeline/Pipeline.vue";
import PipelineBlock from "@/components/shared/pipeline/PipelineBlock.vue";

export default Vue.extend({
  name: "MainPipeline",
  components: {
    Pipeline,
    PipelineBlock
  },
  mounted() {
    window.scrollTo(0, 0);
  }
});
